import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './Switch.css';
import React from 'react';
import { get, getDictionaryItem } from '../../utils';
import { createFacets } from './DropDown';
import addQueryString, { removeQueryString, splitter } from './index';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var replaceUrlPluses = function replaceUrlPluses() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (str) {
    var arr = str.split('');
    var plusIndexes = [];
    arr.forEach(function (item, index) {
      if (item === '+') {
        plusIndexes.push(index);
      }
    });
    if (str.includes('+') && str.includes('%20')) {
      return str.replace(/\%20/g, ' ');
    } else {
      var newStr = str;
      var newStrArr = str.split('');
      plusIndexes.forEach(function (el, i) {
        // 5++days -> 5+ days
        if (el + 1 === plusIndexes[i + 1]) {
          newStrArr[el + 1] = ' ';
          newStr = newStrArr.join('');
          // 1+day -> 1 day
        } else if (plusIndexes.length === 1 && newStrArr[el + 1] !== ' ') {
          newStrArr[el] = ' ';
          newStr = newStrArr.join('');
          // 5+ day
        } else if (plusIndexes.length === 1 && newStrArr[el + 1] === ' ') {
          return str;
        }
        //business+events;,leisure+events;art+&+events
        else {
          newStrArr[el] = ' ';
          newStr = newStrArr.join('');
        }
      });
      return newStr;
    }
  }
  return str;
};
// let currentFacets:any;
var Switch = function Switch(_ref) {
  var fields = _ref.fields,
    facets = _ref.facets,
    setFilter = _ref.setFilter,
    facetsName = _ref.facetsName,
    selectAllLabel = _ref.selectAllLabel,
    day = _ref.day,
    days = _ref.days,
    firstQuery = _ref.firstQuery,
    defaultFacets = _ref.defaultFacets,
    clearAlllFilters = _ref.clearAlllFilters,
    isTagPage = _ref.isTagPage,
    dictionary = _ref.dictionary,
    firstFilter = _ref.firstFilter,
    analytics = _ref.analytics,
    getFilterValue = _ref.getFilterValue,
    rtl = _ref.rtl,
    resetAllFiltersCallback = _ref.resetAllFiltersCallback,
    autoWidth = _ref.autoWidth,
    _ref$summerDeals = _ref.summerDeals24,
    summerDeals24 = _ref$summerDeals === void 0 ? false : _ref$summerDeals,
    _ref$withMapModalView = _ref.withMapModalView,
    withMapModalView = _ref$withMapModalView === void 0 ? false : _ref$withMapModalView;
  var location = useLocation();
  var queryParams = qsToObject(location.search);
  var label = get(fields, 'title.jss.value');
  var tagsToDisplay = get(fields, 'tagsToDisplay.values');
  var selectedTagsToDisplay = get(fields, 'preselectedTags.values');
  var filterName = get(fields, 'name');
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    filteredOptions = _React$useState2[0],
    setfilteredOptions = _React$useState2[1];
  var filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  var showSelectAllOption = get(fields, 'showSelectAllOption.jss.value');
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    state = _React$useState4[0],
    setstate = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    firstLoad = _React$useState6[0],
    setfirstLoad = _React$useState6[1];
  var type = get(fields, 'fieldTypeItem.item.fieldType.value') === 'Toggle Single Select' ? 'radio' : 'checkbox';
  var history = useHistory();
  var checkboxes = React.useRef();
  React.useEffect(function () {
    if (clearAlllFilters) {
      if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
        var preselectedTags = selectedTagsToDisplay.map(function (tag) {
          return get(tag, 'title.value') || get(tag, 'name');
        });
        addQueryString(facetsName, replaceUrlPluses(preselectedTags.join(',')), history);
        getFilterValue && getFilterValue(fields.name, facetsName, replaceUrlPluses(preselectedTags.join(',')));
        setFilter();
        resetAllFiltersCallback();
      } else {
        setstate('');
        var checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
        for (var i = 0; i <= checkboxesArray.length - 1; i++) {
          checkboxesArray[i].checked = false;
        }
        removeQueryString(facetsName, history);
        getFilterValue && getFilterValue(fields.name, facetsName, null);
      }
    }
  }, [clearAlllFilters]);
  React.useEffect(function () {
    var queries = queryParams["".concat(filterType)];
    if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
      var preselectedTags = selectedTagsToDisplay.map(function (tag) {
        return get(tag, 'title.value') || get(tag, 'name');
      });
      if (!queries) {
        addQueryString(facetsName, replaceUrlPluses(preselectedTags.join(',')), history);
        setFilter(true);
      }
    }
  }, []);
  React.useEffect(function () {
    return function () {
      if (!withMapModalView) {
        removeQueryString(facetsName, history);
      }
    };
  }, []);
  var setChecked = function setChecked(key, filterType, index) {
    var queries = queryParams["".concat(filterType)];
    queries = queries && replaceUrlPluses(queries);
    var isChecked = false;
    if (index === 0 && isTagPage && !queries) {
      addQueryString(facetsName, replaceUrlPluses(key), history);
      setFilter();
      isChecked = true;

      // return isChecked;
    }
    queries && queries.split(';,;').map(function (item) {
      if (replaceUrlPluses(item) === key) {
        isChecked = true;
      }
    });
    return isChecked;
  };
  React.useEffect(function () {
    if (firstFilter) {
      setfilteredOptions(createFacets(tagsToDisplay, defaultFacets));
    }
    if (filterType === firstQuery) {
      setfilteredOptions(createFacets(tagsToDisplay, facets));
    } else {
      setfilteredOptions(createFacets(tagsToDisplay, facets));
    }

    //  sortFilters(filteredOptions)
  }, [facets, defaultFacets]);

  // React.useEffect(() => {
  //   if (!firstFilter) {
  //     sortFilters(filteredOptions);
  //   }
  // }, [filteredOptions]);

  var translatedKey = function translatedKey(key) {
    if (isTagPage) {
      return getDictionaryItem(dictionary, "Type.".concat(key));
    } else {
      return key;
    }
  };
  var submitFilters = function submitFilters(e) {
    var checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
    var selectedCheckboxes = [];
    for (var i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
    }
    selectedCheckboxes = selectedCheckboxes.join(splitter);
    addQueryString(facetsName, replaceUrlPluses(selectedCheckboxes), history);
    setFilter();
    getFilterValue && getFilterValue(fields.name, facetsName, replaceUrlPluses(selectedCheckboxes));
  };
  var sortFilters = function sortFilters(arr) {
    if (arr.lenth !== 0) {
      // sort string values
      var sortedValues = arr.map(function (item) {
        return item.key;
      }).sort();
      arr.map(function (item) {
        sortedValues.forEach(function (el, index) {
          if (item.key === el) {
            item.sortedValue = index;
          }
        });
      });
      //sort array of filters objects by sortedValues

      arr.sort(function (a, b) {
        return a.sortedValue - b.sortedValue;
      });
      setfilteredOptions(arr);
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    autoWidth: autoWidth
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select switch"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium filter-toggle-title"
  }, label), /*#__PURE__*/React.createElement("div", {
    ref: checkboxes,
    className: "g-checkbox g-checkbox--mob-scroll ".concat(type === 'radio' ? 'g-checkbox-notick' : '')
  }, filteredOptions && filteredOptions.map(function (item, index) {
    var key = item.key,
      name = item.name;
    return /*#__PURE__*/React.createElement("div", {
      key: key + index,
      className: "g-checkbox__item"
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      value: key,
      defaultChecked: setChecked(key, filterType, index),
      checked: setChecked(key, filterType, index),
      type: type,
      className: "fp__checkbox",
      id: "gct1-".concat(key + index),
      name: "gct1",
      title: translatedKey(key),
      onChange: function onChange(e) {
        tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), summerDeals24 ? "".concat(name ? name : key) : "".concat(filterName, ": ").concat(name ? name : key, " "));
        submitFilters(e);
      },
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.checked = !event.target.checked;
          tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), "".concat(filterName, ": ").concat(name ? name : key, " "));
          submitFilters(event);
        }
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "body-small g-checkbox__label",
      htmlFor: "gct1-".concat(key + index)
    }, translatedKey(key)));
  }), showSelectAllOption && /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox__item"
  }, /*#__PURE__*/React.createElement("input", {
    value: selectAllLabel,
    defaultChecked: false,
    type: type,
    className: "select-all-fp__checkbox",
    id: "gct1-select-all",
    name: "selectAll",
    onChange: function onChange(_ref2) {
      var currentTarget = _ref2.currentTarget;
      var checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
      var selectedCheckboxes = [];
      for (var i = 0; i <= checkboxesArray.length - 1; i++) {
        checkboxesArray[i].checked = true;
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
      currentTarget.checked = false;
      selectedCheckboxes = selectedCheckboxes.toString();
      addQueryString(facetsName, replaceUrlPluses(selectedCheckboxes), history);
      setFilter();
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "body-small g-checkbox__label",
    htmlFor: "gct1-select-all"
  }, selectAllLabel)))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    _ref3$autoWidth = _ref3.autoWidth,
    autoWidth = _ref3$autoWidth === void 0 ? false : _ref3$autoWidth;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyle : ltrStyle, " ").concat(autoWidth ? 'col' : 'col-md-12')
  }, children);
};
export default Switch;
export var commonStyles = "c13pqir1";
var ltrStyle = "l1c0n3b2";
var rtlStyle = "r1kh2763";